"use strict";
$(($) => {
  $('.js-menu').fadeIn(2000);

  $('.js-hamburger').on('click', () => {
    $('.js-hamburger, .js-menu, .hamburger--cart').toggleClass('is-open');
    ("hidden" === $("body").css("overflow") ? $("body").css({
        height: "",
        overflow: ""
    }) : $("body").css({
        height: "100%",
        overflow: "hidden"
    }));
  });



    $('.js-accordion__item').click((event) => {
      const container = $(event.currentTarget).find('.accordion__contents-area');
      container.toggleClass('js-accordion-container');

      // アニメーションを実行した後にクラスを外すための処理
      if(container.hasClass('js-accordion-container')) {
        setTimeout(() => {
          container.removeClass('js-accordion-container');
        }, 500);
      }
    });










    if($('.js-about__slider').length) {
      const optionEvent = {
        mediaQuery: 'min',
        type: "loop",
        autoplay: true,
        perMove: 1,
        perPage: 1,
        padding: '10%',
        pagination: false,
        breakpoints: {
          768: {
            perPage: 3,
          }
        }
      }
      new Splide('.js-about__slider', optionEvent).mount();
    }

    if($('.js-goods__slider').length) {
      const optionEvent = {
        mediaQuery: 'min',
        type: "loop",
        // autoplay: true,
        perMove: 1,
        perPage: 1,
        width: '444px',
        height: '444px',
        pagination: true,
        classes: {
          pagination: 'splide__pagination goods-slider-pagination',
          page : 'splide__pagination__page goods-slider-page',
        },
        breakpoints: {
          768: {
            perPage: 1,
          }
        }
      }
      new Splide('.js-goods__slider', optionEvent).mount();
    }


})
